module.exports = __webpack_public_path__ + "static/media/back_login1.22b333a3.jpg";